<template>
  <ElDialog
    class="modal"
    :visible.sync="showModal"
    :width="modalWidth"
  >
    <h2 class="modal__title modal__text__center">
      К&nbsp;сожалению, мы не&nbsp;можем оформить полис с&nbsp;выбранной суммой остатка по&nbsp;ипотечному кредиту,
      но&nbsp;нашли другие предложения через сервис Сравни
    </h2>
    <div class="modal__body">
      <p class="modal__text modal__text__center">
        Подобрали выгодную страховку в&nbsp;аккредитованных вашим банком компаниях
      </p>
    </div>
    <div class="modal__submit-buttons">
      <BaseButton
        class=""
        text="Посмотреть варианты страховки"
        size="large"
        :long="true"
        @click.native="submitHandler()"
      />
    </div>
  </ElDialog>
</template>

<script>
import modal from '@/mixins/modal';
import BaseButton from '@/components/ui/BaseButton';

export default {
  name: 'ModalFirstStep',
  components: {
    BaseButton
  },
  mixins: [modal],
  props: {
    queryData: Object,
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    submitHandler() {
      const queryString = this.objectToQueryString(this.queryData);
      window.location.href = `/calculators/e-ipoteki/redirectFirstStep.php?${queryString}`;
    },

    objectToQueryString(obj) {
      return Object.keys(obj).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`).join('&');
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  &__text {
    &:not(:last-child) {
      margin-bottom: rem(32);
    }

    &__center {
      text-align: center !important;
    }
  }
}
</style>
